import { api, useLoggedInAuthContext } from 'common';

import { TagAutocompleteField } from './TagAutocomplete/Field';
import { USE_CASE_DESCRIPTIONS } from './useCaseDescriptions';
import { FeatureFlagKey, useFlag } from '../../../../../utils/flags';

interface FlowTagFieldsProps {
  kind: api.Flow.FlowKind;
  customTagFieldName?: string;
  useCaseTagFieldName?: string;
  flowTypeTagFieldName?: string;
  supportedEhrTagFieldName?: string;
}

export function FlowTagFields(props: FlowTagFieldsProps) {
  const {
    kind,
    customTagFieldName = 'customTags',
    useCaseTagFieldName = 'useCaseTag',
    flowTypeTagFieldName = 'flowTypeTag',
    supportedEhrTagFieldName = 'supportedEhrTags',
  } = props;
  const { isAdminRole } = useLoggedInAuthContext();
  const { showTagsOnDialog } = useFlag({
    flagKey: FeatureFlagKey.flowTagOptions,
  });
  const { isUseCaseRequiredEnabled } = useFlag({
    flagKey: FeatureFlagKey.taskBasedPricing,
  });

  // Ignore the feature flag if the kind is template
  // Skills don't have tags
  if (
    (kind !== api.Flow.FlowKind.FlowTemplate && !showTagsOnDialog) ||
    kind === api.Flow.FlowKind.Skill
  ) {
    return null;
  }

  const isTemplate = kind === api.Flow.FlowKind.FlowTemplate;
  return (
    <>
      {!isTemplate && (
        <TagAutocompleteField
          name={customTagFieldName}
          label="Tags (Optional)"
          category={api.FlowDefinitionTemplate.TagCategory.Custom}
          isFreeSolo
          isMultiple
        />
      )}
      <TagAutocompleteField
        name={useCaseTagFieldName}
        label={
          isTemplate || (isAdminRole && isUseCaseRequiredEnabled)
            ? 'Use Case*'
            : 'Use Case (Optional)'
        }
        category={api.FlowDefinitionTemplate.TagCategory.UseCase}
        placeholder="Type to search Use Case..."
        optionDescriptions={USE_CASE_DESCRIPTIONS}
      />
      {isTemplate && (
        <TagAutocompleteField
          name={flowTypeTagFieldName}
          label="Flow Type*"
          category={api.FlowDefinitionTemplate.TagCategory.FlowType}
          placeholder="Type to search Flow Type..."
        />
      )}
      {isTemplate && (
        <TagAutocompleteField
          name={supportedEhrTagFieldName}
          label="Compatible EHRs*"
          category={api.FlowDefinitionTemplate.TagCategory.SupportedEhr}
          placeholder="Search compatible EHRs..."
          isMultiple
        />
      )}
    </>
  );
}
